/* global slideUp, slideDown, windowWidth, breakpointMd */
// **************************************************
// Philosophy toggle
// **************************************************
const ourPhilosophy = document.querySelector('.our-philosophy');

if (ourPhilosophy) {
  const openPhilosophies = document.querySelectorAll('.open-philosophy');

  if (windowWidth() < breakpointLg) {
    openPhilosophies.forEach((openPhilosophy) => {
      openPhilosophy.addEventListener('click', () => {
        const clicked = openPhilosophy.getAttribute('data-philosophy');
        const targets = ourPhilosophy.querySelectorAll(`[data-philosophy="${clicked}"]`);
        const activeItems = ourPhilosophy.querySelectorAll('.is-active');

        if (openPhilosophy.classList.contains('is-active')) {
          activeItems.forEach((activeItem) => {
            activeItem.classList.remove('is-active');
          });
          targets.forEach((target) => {
            target.classList.remove('is-active');
            const targetContent = target.querySelector('.our-philosophy__item-content');
            if (targetContent) {
              slideUp(targetContent, 300);
            }
          });
        } else {
          activeItems.forEach((activeItem) => {
            activeItem.classList.remove('is-active');

            const activeContent = activeItem.querySelector('.our-philosophy__item-content');
            if (activeContent) {
              slideUp(activeContent, 300);
            }
          });
          targets.forEach((target) => {
            target.classList.add('is-active');
            const targetContent = target.querySelector('.our-philosophy__item-content');
            if (targetContent) {
              slideDown(targetContent, 300);
            }
          });
        }
      });
    });
  } else {
    openPhilosophies.forEach((openPhilosophy) => {
      openPhilosophy.addEventListener('mouseenter', () => {
        const clicked = openPhilosophy.getAttribute('data-philosophy');
        const targets = ourPhilosophy.querySelectorAll(`[data-philosophy="${clicked}"]`);
        const activeItems = ourPhilosophy.querySelectorAll('.is-active');

        if (openPhilosophy.classList.contains('is-active')) {
          activeItems.forEach((activeItem) => {
            activeItem.classList.remove('is-active');
          });
          targets.forEach((target) => {
            target.classList.remove('is-active');
            const targetContent = target.querySelector('.our-philosophy__item-content');
            if (targetContent) {
              slideUp(targetContent, 300);
            }
          });
        } else {
          activeItems.forEach((activeItem) => {
            activeItem.classList.remove('is-active');

            const activeContent = activeItem.querySelector('.our-philosophy__item-content');
            if (activeContent) {
              slideUp(activeContent, 300);
            }
          });
          targets.forEach((target) => {
            target.classList.add('is-active');
            const targetContent = target.querySelector('.our-philosophy__item-content');
            if (targetContent) {
              slideDown(targetContent, 300);
            }
          });
        }
      });

      openPhilosophy.addEventListener('mouseleave', () => {
        const clicked = openPhilosophy.getAttribute('data-philosophy');
        const targets = ourPhilosophy.querySelectorAll(`[data-philosophy="${clicked}"]`);
        const activeItems = ourPhilosophy.querySelectorAll('.is-active');

        activeItems.forEach((activeItem) => {
          activeItem.classList.remove('is-active');
        });
        targets.forEach((target) => {
          target.classList.remove('is-active');
          const targetContent = target.querySelector('.our-philosophy__item-content');
          if (targetContent) {
            slideUp(targetContent, 300);
          }
        });
      });
    });
  };
}
